import { Routes } from '@angular/router';
import { ProgramComponent } from './program.component';
import { MyStudiesComponent } from './my-studies.component';
import { MyListsComponent } from './my-lists.component';
import { RouteAccessService } from '../../shared';

export const PROGRAM_ROUTES: Routes = [{
    path: 'programs',
    component: ProgramComponent,
    data: {
        authorities: []
    },
    canActivate: [RouteAccessService],
    children: [{
        path: '',
        pathMatch: 'full',
        redirectTo: 'my-studies'
    }, {
        path: 'my-studies',
        component: MyStudiesComponent,
        data: { pageTitle: 'program.my.studies.tab.name' }
    }, {
        path: 'my-lists',
        component: MyListsComponent,
        data: { pageTitle: 'program.my.lists.tab.name' }
    }]
}];
